/* unplugin-vue-components disabled */const { computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-18ae3886"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "out-in-type-label" };
const model_1 = require("@/model");
const index_vue_1 = tslib_1.__importDefault(require("@/components/SensitiveInput/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/components/DeleteBtn/index.vue"));
const index_vue_3 = tslib_1.__importDefault(require("@/components/IoInput/index.vue"));
const work_1 = require("@/store/modules/work");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NumericsItem',
    props: {
        item: {},
        handleDelIO: {},
        beforeChange: { type: Function, default: (val) => true }
    },
    emits: ['onChange', 'update:item.name'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const nameModel = computed({
            get: () => props.item.name,
            set: (value) => emit('onChange', value, remarkModel.value)
        });
        const remarkModel = computed({
            get: () => props.item.remark,
            set: (value) => emit('onChange', nameModel.value, value)
        });
        const store = (0, work_1.useWork)();
        function onChange() {
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(index_vue_3.default, {
                    model: (0, vue_2.unref)(nameModel),
                    "onUpdate:model": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(nameModel) ? (nameModel).value = $event : null)),
                    item: _ctx.item,
                    class: "name-label",
                    onOnChange: onChange
                }, null, 8, ["model", "item"]),
                (0, vue_2.createElementVNode)("span", _hoisted_1, (0, vue_2.toDisplayString)(_ctx.item.type === (0, vue_2.unref)(model_1.IO_TYPE).DI || _ctx.item.type === (0, vue_2.unref)(model_1.IO_TYPE).AI ? '输入' : '输出'), 1),
                (0, vue_2.createVNode)(index_vue_1.default, {
                    model: (0, vue_2.unref)(remarkModel),
                    "onUpdate:model": _cache[1] || (_cache[1] = ($event) => ((0, vue_2.isRef)(remarkModel) ? (remarkModel).value = $event : null)),
                    placeholder: "请输入注释",
                    class: "remark-input",
                    onOnChange: onChange,
                    isNullable: true
                }, null, 8, ["model"]),
                (0, vue_2.createVNode)(index_vue_2.default, {
                    title: "确定删除这个I/O吗?",
                    onDelConfirm: _cache[2] || (_cache[2] = ($event) => (_ctx.handleDelIO(_ctx.item)))
                })
            ], 64));
        };
    }
});
